import { IRoomUserCommunityReach } from "../../types/app_chat";
import { IAppChatState, IChannel, IChatState, IDirectMessage } from "../../types/chat";
import { CANCEL_IS_EDIT_MESSAGE_CommunityReach, CREATE_CHANNEL_CommunityReach, CREATE_CHANNEL_CommunityReach_ERROR, CREATE_CHANNEL_CommunityReach_LOADING, DELETE_MESSAGE_CommunityReach, GET_AUTOCOMPLETE_USERS_LIST_ERROR_CommunityReach, GET_AUTOCOMPLETE_USERS_LIST_CommunityReach, GET_CHANNEL_INFO_ERROR_CommunityReach, GET_CHANNEL_INFO_CommunityReach, GET_JOINED_CHANNELS_LIST_ERROR_CommunityReach, GET_JOINED_CHANNELS_LIST_CommunityReach, GET_MESSAGES_ERROR_CommunityReach, GET_MESSAGES_CommunityReach, GET_ROOM_DATA_CommunityReach, GET_CHAT_USERS_INFO_ERROR_CommunityReach, GET_CHAT_USERS_INFO_CommunityReach, SEND_MESSAGE_CommunityReach, SET_ENTERED_TEXT_CommunityReach, SET_IS_EDIT_MESSAGE_CommunityReach, SET_MESSAGE_ID_CommunityReach, UPDATE_MESSAGE_CommunityReach, UPLOAD_FILE_TO_ROOM_CommunityReach, GET_USER_PROFILE_INFO_CommunityReach, GET_USER_PROFILE_INFO_ERROR_CommunityReach, UPDATE_MESSAGE_LIST_SO_CommunityReach, CHAT_MEMBERS, GET_CHANNEL_MEMBER_INFO_ERROR, GET_PRIVATE_CHAT_INFO_CommunityReach, GET_PRIVATE_CHAT_INFO_ERROR_CommunityReach, GET_ACTIVE_MESSAGE, CHANNEL_MEMBERS, SEND_DIRECT_MESSAGE_CommunityReach, GET_LATEST_CHAT_USER, SET_ACTIVE_MESSAGE, SET_EDIT_MESSAGE, DELETE_DIRECT_MESSAGE_CommunityReach, LAST_CHAT_ROOM } from "../../types/index";

const initialState: IAppChatState = {
  directMessagesList: [],
  editMessageId: "",
  latestChatUser: [],
  lastChatRoom: null,
  channelMembers: [],
  activeMessages: [],
  messages: [],
  channels: [],
  autoCompleteUsersList: [],
  chatUserInfo: null,
  userProfileInfo: null,
  chatChannelInfo: null,
  error: "",
  loading: false,
  isEditMessage: false,
  enteredText: "",
  messageId: "",
  members: []
};

const chatReducer = (state = initialState, action): IAppChatState => {
  switch (action.type) {
    case SET_EDIT_MESSAGE:
      return {
        ...state,
        editMessageId: action.payload
      };
    case LAST_CHAT_ROOM:
      return {
        ...state,
        error: "",
        lastChatRoom: action.payload
      };

    case GET_PRIVATE_CHAT_INFO_CommunityReach:
      return {
        ...state,
        error: "",
        directMessagesList: action.payload,
        loading: false
      };
    case SEND_DIRECT_MESSAGE_CommunityReach:
      return {
        ...state,
        error: "",
        directMessagesList: [...state.directMessagesList, action.payload]
      };
    case GET_LATEST_CHAT_USER:
      return {
        ...state,
        error: "",
        latestChatUser: action.payload
      };


    case CHANNEL_MEMBERS:
      return {
        ...state,
        error: "",
        channelMembers: action.payload,
        loading: false
      };

    case GET_ACTIVE_MESSAGE:
      return {
        ...state,
        error: "",
        activeMessages: action.payload
      };
    case SET_ACTIVE_MESSAGE:
      return {
        ...state,
        error: "",
        activeMessages: action.payload
      };
    case GET_PRIVATE_CHAT_INFO_ERROR_CommunityReach:
      return {
        ...state,
        error: action.payload,
      };
    case GET_MESSAGES_CommunityReach:
      return {
        ...state,
        error: "",
        messages: action.payload,
      };
    case GET_MESSAGES_ERROR_CommunityReach:
      return {
        ...state,
        error: action.payload,
      };
    case SEND_MESSAGE_CommunityReach:
      return {
        ...state,
        error: "",
        messages: [...state.messages, action.payload],
      };
    case UPDATE_MESSAGE_CommunityReach:
      return {
        ...state,
        messages: state.messages.map((message) =>
          message._id === action.payload._id ? action.payload : message
        ),
        isEditMessage: false,
        enteredText: "",
        messageId: ""
      };
    case DELETE_MESSAGE_CommunityReach:
      return {
        ...state,
        messages: state.messages.filter((el) => el._id !== action.payload._id)
      };
    case DELETE_DIRECT_MESSAGE_CommunityReach:
      return {
        ...state,
        directMessagesList: state.directMessagesList.filter((el) => el._id !== action.payload._id)
      };
    case GET_JOINED_CHANNELS_LIST_CommunityReach:
      return {
        ...state,
        channels: action.payload as IRoomUserCommunityReach[],
      };
    case GET_JOINED_CHANNELS_LIST_ERROR_CommunityReach:
      return {
        ...state,
        error: action.payload,
      };
    case CREATE_CHANNEL_CommunityReach_LOADING:
      return {
        ...state,
        loading: true,
        error: ""
      };
    case CREATE_CHANNEL_CommunityReach:
      return {
        ...state,
        channels: [...state.channels, ...action.payload.data],
        loading: false
      };
    case CREATE_CHANNEL_CommunityReach_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case GET_AUTOCOMPLETE_USERS_LIST_CommunityReach:
      return {
        ...state,
        autoCompleteUsersList: action.payload,
      };
    case GET_AUTOCOMPLETE_USERS_LIST_ERROR_CommunityReach:
      return {
        ...state,
        error: action.payload,
      };
    case GET_CHAT_USERS_INFO_CommunityReach:
      return {
        ...state,
        chatUserInfo: action.payload,
      };
    case GET_CHAT_USERS_INFO_ERROR_CommunityReach:
      return {
        ...state,
        error: action.payload,
      };
    case GET_USER_PROFILE_INFO_CommunityReach:
      return {
        ...state,
        userProfileInfo: action.payload,
      };
    case GET_USER_PROFILE_INFO_ERROR_CommunityReach:
      return {
        ...state,
        error: action.payload,
      };
    case GET_CHANNEL_INFO_CommunityReach:
      return {
        ...state,
        error: "",
        chatChannelInfo: action.payload,
      };
    case GET_CHANNEL_INFO_ERROR_CommunityReach:
      return {
        ...state,
        error: action.payload,
      };
    case UPLOAD_FILE_TO_ROOM_CommunityReach:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };
    case SET_IS_EDIT_MESSAGE_CommunityReach:
      return {
        ...state,
        isEditMessage: action.payload,
      };
    case CANCEL_IS_EDIT_MESSAGE_CommunityReach:
      return {
        ...state,
        isEditMessage: action.payload,
        enteredText: "",
        messageId: ""
      };
    case SET_ENTERED_TEXT_CommunityReach:
      return {
        ...state,
        enteredText: action.payload,
      };
    case SET_MESSAGE_ID_CommunityReach:
      return {
        ...state,
        messageId: action.payload,
      };
    case UPDATE_MESSAGE_LIST_SO_CommunityReach: {
      return {
        ...state,
        messages: [...state.messages, action.payload]
      };
    };
    case CHAT_MEMBERS: {
      return {
        ...state,
        members: [...action.payload]
      };
    }
    default:
      return state;
  }
};

export default chatReducer
